var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipmentQuotesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3867 20.75H21.8867C18.573 20.75 15.8867 23.4363 15.8867 26.75V46.25C15.8867 49.5638 18.573 52.25 21.8867 52.25H53.3867C56.7005 52.25 59.3867 49.5638 59.3867 46.25V26.75C59.3867 23.4363 56.7005 20.75 53.3867 20.75Z",
    fill: "#DDD6FE",
    stroke: "#5A31FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3877 36.4999C44.3877 41.8846 41.3655 46.2499 37.6377 46.2499C33.9099 46.2499 30.8877 41.8846 30.8877 36.4999C30.8877 31.1152 33.9099 26.7499 37.6377 26.7499C41.3655 26.7499 44.3877 31.1152 44.3877 36.4999Z",
    stroke: "#5A31FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3877 43.25C21.5298 43.25 24.8877 46.6079 24.8877 50.75",
    stroke: "#5A31FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8853 43.25C53.7432 43.25 50.3853 46.6079 50.3853 50.75",
    stroke: "#5A31FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3877 29.7499C21.5298 29.7499 24.8877 26.392 24.8877 22.2499",
    stroke: "#5A31FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8853 29.7499C53.7432 29.7499 50.3853 26.392 50.3853 22.2499",
    stroke: "#5A31FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentQuotesIcon);
export default __webpack_public_path__ + "static/media/shipment-quotes-icon.f991e39a755972e0188daa58c5aa573d.svg";
export { ForwardRef as ReactComponent };